import React from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { IContentPaneProps } from "./OutageReconciliation.types";
import SharedButtonStyles from "../../../shared/styled-components/buttons";
import BUTTON from "../../button/Button.component";
import FormStyles from "../../form/Form.styles";
import { Formik, FormikHelpers } from "formik";
import FormUtils from "../../form/Form.utils";
import FormConstants from "../../form/Form.constants";
import { IAcceptOutageValues } from "../../form/Form.types";
import { updateAdminOutage } from "../../../state-management/slices/outages/outages.thunk";
import { useDispatch } from "react-redux";
import { BaseMapService } from "../../map/BaseMap.service";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { FeatureLayerService } from "../../map/FeatureLayer.service";
import MapUtils from "../../map/Map.utils";

const ACCEPT_PANE: React.FC<IContentPaneProps> = (props: IContentPaneProps) => {
  const dispatch = useDispatch();
  const sendDataToGTM = useGTMDispatch();

  const { handleClose, selectedOutage } = props;

  // Services
  const baseMapService: BaseMapService = BaseMapService.getInstance(
    dispatch,
    sendDataToGTM
  );
  const featureLayerService: FeatureLayerService =
    baseMapService.getFeatureLayerService();

  return (
    <FormStyles.FormContainer
      className="form-container"
      data-testid="accept-outage-form"
    >
      <Formik
        validationSchema={FormUtils.acceptOutageSchema}
        initialValues={FormConstants.InitialAcceptOutageValues}
        onSubmit={async (
          values: IAcceptOutageValues,
          actions: FormikHelpers<IAcceptOutageValues>
        ) => {
          let gisFeature: any;

          if (values.acceptOutageFormGISID) {
            gisFeature = await featureLayerService.getFeatureById(
              values.acceptOutageFormGISID
            );
          }

          if (selectedOutage && gisFeature) {
            dispatch(
              updateAdminOutage(
                selectedOutage,
                baseMapService,
                sendDataToGTM,
                gisFeature,
                values.acceptOutageFormGISID
              )
            );
          } else {
            console.log("There was a problem accepting outage:", {
              selectedOutage,
              "GIS Feature": gisFeature,
            });
          }
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          resetForm,
        }) => (
          <Form id="AcceptOutageForm" noValidate onSubmit={handleSubmit}>
            <FormStyles.FormGroup controlId="acceptOutageFormNumberCtrl">
              <FormStyles.FormLabel className="form-label">
                Enter GISID
              </FormStyles.FormLabel>
              <FormStyles.FormControl
                required
                type="number"
                name="acceptOutageFormGISID"
                className={
                  touched.acceptOutageFormGISID && errors.acceptOutageFormGISID
                    ? "search-input is-invalid"
                    : "search-input"
                }
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={
                  touched.acceptOutageFormGISID && !errors.acceptOutageFormGISID
                }
                value={values.acceptOutageFormGISID}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.acceptOutageFormGISID}
              </Form.Control.Feedback>
            </FormStyles.FormGroup>
            <FormStyles.FormSubmitContainer className="form-submit-container">
              <Container fluid>
                <Row>
                  <Col>
                    <SharedButtonStyles.BlueSecondaryButton
                      className="blue-secondary-button block"
                      onClick={handleClose}
                    >
                      Cancel
                    </SharedButtonStyles.BlueSecondaryButton>
                  </Col>
                  <Col>
                    <BUTTON type="submit" className="block" variant="primary">
                      Accept
                    </BUTTON>
                  </Col>
                </Row>
              </Container>
            </FormStyles.FormSubmitContainer>
          </Form>
        )}
      </Formik>
    </FormStyles.FormContainer>
  );
};

export default ACCEPT_PANE;
